export function isClubRsvpConfigEnabled(data) {
  if (data === true || data === 1 || data === "true") {
    return true;
  }
  if (data && typeof data === "object") {
    return data.rsvprequired === true
      || data.rsvpRequired === true
      || data.isRsvpEnabled === true;
  }
  return false;
}

export function rsvpRequestsFromResponse(data) {
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.requests)) {
    return data.requests;
  }
  if (Array.isArray(data?.content)) {
    return data.content;
  }
  return [];
}

export function shouldShowDashboardRsvp(isClubEnabled, requests) {
  return Boolean(isClubEnabled) || (Array.isArray(requests) && requests.length > 0);
}
